import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Revenue } from '../../_models/financials/revenue';

@Injectable()
export class RevenuesService {
  private apiBaseUrl = environment.financeServiceUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<Revenue[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes')
      .pipe(map((response) => response));
  }

  getListByYear(year): Observable<Revenue[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes?cropYear=' + year)
      .pipe(map((response) => response));
  }

  get(id: number): Observable<Revenue> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes/' + id + '')
      .pipe(map((response) => response));
  }

  getRevenuesByGroupId(id): Observable<Revenue[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes?groupId=' + id)
      .pipe(map((response) => response));
  }

  // Metodo save per singola entità Revenue
  save(revenueItem): Observable<Revenue> {
    const revenue = { ...revenueItem };
    delete revenue.lastUpdated;
    delete revenue.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    revenue.tenantId = companySelected ? companySelected.id : null;

    if (revenue.user != null && revenue.user.id != null) {
      revenue.user = { id: revenue.user.id };
    }

    if (revenue.id) {
      return this.http
        .put<Revenue>(
          this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes/' + revenue.id,
          revenue
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Revenue>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes', revenue)
        .pipe(map((response) => response));
    }
  }

  // Metodo saveMulti per l'invio di un array di entità Revenue
  saveMulti(revenues: Revenue[]): Observable<Revenue[]> {
    return this.http
      .post<Revenue[]>(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes/multi', revenues)
      .pipe(map((response) => response));
  }

  delete(revenue: Revenue): Observable<Revenue> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/finance/invoice/incomes/' + revenue.id)
      .pipe(
        map(() => {
          return { id: revenue.id } as Revenue;
        })
      );
  }

  getCategoryService = (): Array<string> => {
    return ['income_contribute', 'income_assurance', 'income_other'];
  };

  getCategoryServiceForCropPlanning = (): Array<string> => {
    return ['income_contribute', 'income_assurance', 'income_crop', 'income_other'];
  };
}
